var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-3423 1286) rotate(-90)"},[React.createElement("path",{"d":"M-311.609,385.78l-5,5-5-5","transform":"translate(1592.609 3044.22)","fill":"none","stroke":"#0c2340","strokeMiterlimit":"10","strokeWidth":"1.5","opacity":"0.9","key":0}),React.createElement("rect",{"width":"20","height":"20","transform":"translate(1266 3423)","fill":"none","key":1})]));
}

Arrow.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Arrow;

Arrow.default = Arrow;
